import { Module } from '@moonpig/web-shared-products'

export const createCardFrictionlessFlowConfiguration = (): Module[] => {
  return [
    {
      __typename: 'ModuleTwoColumn',
      left: [{ __typename: 'ModuleImages' }],
      right: [
        { __typename: 'ModuleHeading' },
        { __typename: 'ModuleMemberPricingHeader' },
        {
          __typename: 'ModuleVariantTabs',
          modules: [
            { __typename: 'ModulePromotions' },
            { __typename: 'ModuleDispatch' },
          ],
        },
        { __typename: 'ModuleButtons' },
      ],
    },
  ]
}
